import React from 'react';

const MoreInfoIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.99739 13.3337V10.0003M9.99739 6.66699H10.0057M18.3307 10.0003C18.3307 14.6027 14.5998 18.3337 9.99739 18.3337C5.39502 18.3337 1.66406 14.6027 1.66406 10.0003C1.66406 5.39795 5.39502 1.66699 9.99739 1.66699C14.5998 1.66699 18.3307 5.39795 18.3307 10.0003Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default MoreInfoIcon;
